import React from "react";
import { useReveal } from "@/hooks/useReveal";

const TEAM = [
  {
    id: "joana",
    name: "Joana Duarte",
    role: "Fundadora · Pilates",
    bio: "Licenciada em Psicologia do Desporto e Educação Física, especialista em Pilates desde 2018. Lidera o estúdio com uma abordagem atenta e cuidadosa.",
    image: "/media/luft-team-joana.jpg",
    objectPosition: "center 30%",
  },
  {
    id: "joao",
    name: "João Alves",
    role: "Yoga · Ayurveda",
    bio: "Professor de Yoga e terapeuta de Ayurveda. Acompanha cada aluno com uma abordagem próxima, consciente e profundamente humana.",
    image: "/media/luft-team-joao.jpg",
    objectPosition: "center 30%",
  },
  {
    id: "thayna",
    name: "Thayná Lira",
    role: "Fisioterapia · Pilates",
    bio: "Fisioterapeuta formada em Pilates. Combina conhecimento clínico e prática consciente, em aulas de grupo ou sessões individuais.",
    image: "/media/luft-team-thayna.jpg",
    objectPosition: "center 25%",
  },
  {
    id: "roberta",
    name: "Roberta Brazil",
    role: "Pilates · Geriatria",
    bio: "Instrutora de Pilates e licenciada em Educação Física. Dedica especial atenção ao trabalho com pessoas séniores, com uma prática paciente, cuidadosa e profundamente humana.",
    image: "/media/luft-team-roberta.jpg",
    objectPosition: "center 30%",
    noFilter: true,
  },
];

export default function Team() {
  const ref = useReveal();

  return (
    <section
      id="equipa"
      ref={ref}
      className="relative bg-[var(--luft-bg-alt)] py-32 sm:py-44 lg:py-52"
      data-testid="team-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 mb-24 reveal">
          <div>
            <p className="eyebrow mb-8">07 — Equipa</p>
            <h2 className="editorial-heading text-[clamp(2.2rem,5.4vw,4.4rem)] text-[var(--luft-ink)] max-w-3xl">
              Pessoas que <em className="editorial-italic">cuidam</em><br />
              de pessoas.
            </h2>
          </div>
          <p className="font-body font-light text-[var(--luft-ink-soft)] max-w-sm leading-relaxed">
            Uma equipa reduzida, formada e dedicada a uma prática consciente e personalizada.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 lg:gap-x-12 gap-y-20">
          {TEAM.map((person) => (
            <article
              key={person.id}
              className="reveal group"
              data-testid={`team-member-${person.id}`}
            >
              <div className="aspect-[4/5] overflow-hidden" style={{ borderRadius: "var(--radius-organic)" }}>
                <img
                  src={person.image}
                  alt={person.name}
                  loading="lazy"
                  className={person.noFilter ? "w-full h-full object-cover" : "team-portrait w-full h-full object-cover"}
                  style={{ objectPosition: person.objectPosition || "center top" }}
                />
              </div>
              <div className="mt-8">
                <p className="eyebrow text-[var(--luft-blue)]">{person.role}</p>
                <h3 className="editorial-heading text-3xl text-[var(--luft-ink)] mt-3">
                  {person.name}
                </h3>
                <p className="mt-5 text-[var(--luft-ink-soft)] font-body font-light text-sm leading-relaxed">
                  {person.bio}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
